import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_materials_navigational_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { ownerId?: number, projectId?: number, fullTextSearch?: string, materialIds?: number[] }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, Description?: string, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, PrimaryPickTotals?: { TotalLocationCount?: number, TotalPackagedAmount?: number, MaterialId?: number }, NonPrimaryPickTotals?: { TotalLocationCount?: number, TotalPackagedAmount?: number, MaterialId?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { ownerId?: number, projectId?: number, fullTextSearch?: string, materialIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, Description?: string, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, PrimaryPickTotals?: { TotalLocationCount?: number, TotalPackagedAmount?: number, MaterialId?: number }, NonPrimaryPickTotals?: { TotalLocationCount?: number, TotalPackagedAmount?: number, MaterialId?: number } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { ownerId?: number, projectId?: number, fullTextSearch?: string, materialIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ControllerTypeId?: number, Description?: string, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, PrimaryPickTotals?: { TotalLocationCount?: number, TotalPackagedAmount?: number, MaterialId?: number }, NonPrimaryPickTotals?: { TotalLocationCount?: number, TotalPackagedAmount?: number, MaterialId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      ownerId?: number, projectId?: number, fullTextSearch?: string, materialIds?: number[]    }) {
      return false;
    }
}
